"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFabricFalconyAnnouncementsOptions = exports.FalconyAnnouncementsTransition = exports.FalconyAnnouncementsTheme = void 0;
const objects_1 = require("./objects");
var FalconyAnnouncementsTheme;
(function (FalconyAnnouncementsTheme) {
    FalconyAnnouncementsTheme["default"] = "default";
    // light = 'light',
    // dark = 'dark'
    // custom = 'custom'
})(FalconyAnnouncementsTheme = exports.FalconyAnnouncementsTheme || (exports.FalconyAnnouncementsTheme = {}));
var FalconyAnnouncementsTransition;
(function (FalconyAnnouncementsTransition) {
    FalconyAnnouncementsTransition["instant"] = "instant";
    FalconyAnnouncementsTransition["fade"] = "fade";
    FalconyAnnouncementsTransition["slideRight"] = "slideRight";
    FalconyAnnouncementsTransition["slideLeft"] = "slideLeft";
    FalconyAnnouncementsTransition["slideUp"] = "slideUp";
    FalconyAnnouncementsTransition["slideDown"] = "slideDown";
})(FalconyAnnouncementsTransition = exports.FalconyAnnouncementsTransition || (exports.FalconyAnnouncementsTransition = {}));
exports.isFabricFalconyAnnouncementsOptions = (item) => (item === null || item === void 0 ? void 0 : item.type) === objects_1.ObjectType.CustomFalconyAnnouncements;
//# sourceMappingURL=falconyAnnouncements.js.map